import React from "react";
import { TextTypes } from "../../../../../styles/fonts";
import { Text } from "../../../../Text/Text";
import { TruncatedText } from "../../../../TruncatedText/TruncatedText";
import { ListItemMedia, ListItemMediaProps } from "../../../ListItems/blocks/ListItemMedia/ListItemMedia";
import { TextTitleColumnProps } from "../TextTitleColumn/TextTitleColumn";

export interface MediaTitleColumnProps extends TextTitleColumnProps {
    /**
     * ListItemMedia props to create the title media element.
     */
    readonly listItemMediaProps: ListItemMediaProps;

    /**
     * Style (size/weight/color) for the component, see figma in readme for
     * reference
     */
    readonly titleTextVariant?: TextTypes;
}

export const MediaTitleColumn: React.FC<MediaTitleColumnProps> = ({
    listItemMediaProps,
    title,
    titleTextVariant,
    isTitleSemiBold = false,
    subtitles = [],
    disabled,
    truncatedTitleTextProps,
    truncatedSubtitleTextProps
}) => {
    return (
        <ListItemMedia {...listItemMediaProps}>
            {truncatedTitleTextProps ? (
                <TruncatedText
                    lines={truncatedTitleTextProps.lines}
                    stopPropagation={truncatedTitleTextProps.stopPropagation}
                    children={title}
                    variant={titleTextVariant}
                    weightOverride={isTitleSemiBold ? "semi-bold" : undefined}
                    disabled={disabled}
                />
                ) :
                <Text variant={titleTextVariant} weightOverride={isTitleSemiBold ? "semi-bold" : undefined} children={title} disabled={disabled} />
            }

            {subtitles.map((subtitle, index) =>
                truncatedSubtitleTextProps ? (
                    <TruncatedText
                        lines={truncatedSubtitleTextProps.lines}
                        stopPropagation={truncatedSubtitleTextProps.stopPropagation}
                        {...subtitle}
                        disabled={disabled}
                        key={index}
                    />
                ) :
                <Text {...subtitle} disabled={disabled} key={index} />
            )}
        </ListItemMedia>
    );
};
